import { render, staticRenderFns } from "./IndicatorPieChart.vue?vue&type=template&id=b06f7626&scoped=true"
import script from "./IndicatorPieChart.vue?vue&type=script&lang=js"
export * from "./IndicatorPieChart.vue?vue&type=script&lang=js"
import style0 from "./IndicatorPieChart.vue?vue&type=style&index=0&id=b06f7626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06f7626",
  null
  
)

export default component.exports